import { NonBreakingDate } from '@pages/messages/NonBreakingDate';
import { formatNumberAmount } from '@utils/utils';
import { TFunction } from 'i18next';
import type { FXPayment } from 'types/operations';

import type { CardConfig } from '../types';

export const getFXPaymentDetails = (operation: FXPayment, t: TFunction): CardConfig => ({
	title: t('paymentDetails.title'),
	groups: [
		{
			fields: [
				{
					title: t('paymentDetails.description'),
					content: operation?.payment_details,
				},
				{
					title: t('paymentDetails.amount'),
					content: operation?.amount
						? formatNumberAmount(operation.amount.toFixed(2))
						: null,
				},
				{
					title: t('paymentDetails.currency'),
					content: operation?.currency,
				},
				{
					title: t('paymentDetails.receivedAmount'),
					content: formatNumberAmount(operation.fx_quote.amount_to_formatted),
				},
				{
					title: t('paymentDetails.receivedCurrency'),
					content: operation?.fx_quote.currency_to,
				},
				{
					title: t('paymentDetails.type.title'),
					content: t(
						`paymentDetails.type.options.${operation?.payment_type?.toLowerCase()}`,
					),
				},
				{
					title: t('paymentDetails.priority.title'),
					content: t(
						`paymentDetails.priority.options.${operation?.payment_urgency?.toLowerCase()}`,
					),
				},
				{
					title: t('paymentDetails.paymentDate'),
					content: operation?.created_at ? (
						<NonBreakingDate date={operation.created_at} />
					) : null,
				},
				{
					title: t('paymentDetails.settledAtDate'),
					content: operation?.settled_at ? (
						<NonBreakingDate date={operation.settled_at} />
					) : null,
				},
				{
					title: t('paymentDetails.status.title'),
					content: t(`paymentDetails.status.statuses.${operation?.status}`),
				},
				{
					title: t('paymentDetails.operationNo'),
					content: operation?.document_number,
				},
			],
		},
	],
});
